import { Col, Form, Row } from 'react-bootstrap'
import { emptyDate, isEmptyDate } from '../../../utils/emptyDate'
import React, { useCallback, useEffect, useState } from 'react'
import CustomDatePicker from '../../Forms/CustomDatePicker'
import { getIsoDate } from '../../../utils/getIsoDate'
import { useTranslation } from 'react-i18next'
import { StyledValidationMessage } from '../../Employees/Form/formHelper'
import MandatoryField from '../../MandatoryField/MandatoryField'
//import WarehousesSelect from '../Form/WarehousesSelect'
import CreateOfficeSelect from '../Form/CreateOfficeSelect'

const ArticleInstanceExpiringWarrantiesStatistic = ({ formData, setFormData, formErrors }) => {
    const { t } = useTranslation()
    const [dateFrom, setDateFrom] = useState(null)
    const [dateTo, setDateTo] = useState(null)
    const [/*warehouseSelection*/, setWarehouseSelection] = useState(true)

    useEffect(() => {
        setFormData(prev => {
            if (dateFrom) {
                return { ...prev, startDate: getIsoDate(dateFrom, false) }
            }
            delete prev.startDate
            return prev
        })
    }, [setFormData, dateFrom])
    useEffect(() => {
        setFormData(prev => {
            if (dateFrom) {
                let isoDate = getIsoDate(dateTo, true)
                return { ...prev, endDate: isEmptyDate(isoDate) ? emptyDate : isoDate }
            }
            delete prev.endDate
            return prev
        })
    }, [setFormData, dateTo, dateFrom])
    const handleChangeDate = useCallback(setDate => date => {
        setDate(date)
    }, [])
    const updateCheckboxAndRadioProperty = (event, name) => {
        switch (name) {
            case 'articleInStock':
                setWarehouseSelection(true)
                setFormData(prev => ({
                    ...prev,
                    articleInStock: true
                }))
                break
            case 'articleOutStock':
                setWarehouseSelection(false)
                setFormData(prev => ({
                    ...prev,
                    articleInStock: false
                }))
                break
            case 'includeSubordinatedOffices':
                setFormData(prev => ({
                    ...prev,
                    includeSubordinatedOffices: event.target.checked
                }))
                break
            default:
        }
    }

    return (
        <div>
            <>
                <Row>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label>{`${t('from')}${'*'}`}</Form.Label>
                            <CustomDatePicker
                                dateFormat="dd.MM.yyyy"
                                placeholderText={t('date')}
                                onChange={handleChangeDate(setDateFrom)}
                                showYearDropdown
                                selected={dateFrom}
                                isInvalid={formErrors && formErrors.startDate}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label>{`${t('to')}${'*'}`}</Form.Label>
                            <CustomDatePicker
                                dateFormat="dd.MM.yyyy"
                                placeholderText={t('date')}
                                onChange={handleChangeDate(setDateTo)}
                                showYearDropdown
                                selected={dateTo}
                                isInvalid={formErrors && formErrors.endDate}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                {formErrors && formErrors.startDate && <StyledValidationMessage>{formErrors.startDate}</StyledValidationMessage>}
                {formErrors && formErrors.endDate && <StyledValidationMessage>{formErrors.endDate}</StyledValidationMessage>}
            </>
            {/*<Form.Group className="mb-3">
                <Form.Check
                    inline
                    type="radio"
                    id="articleInStock"
                    name="warehouseSelection"
                    label={t('reportConfig:articleInStock')}
                    checked={warehouseSelection}
                    onChange={(e) => updateCheckboxAndRadioProperty(e, 'articleInStock')}
                />
                <WarehousesSelect
                    name="includedWarehouseIDs"
                    value={formData.includedWarehouseIDs}
                    setFormData={setFormData}
                    disabled={!warehouseSelection}
                />
            </Form.Group>*/}
            <Form.Group className="mb-3">
                {/*<Form.Check
                    inline
                    type="radio"
                    id="articleOutStock"
                    name="warehouseSelection"
                    label={t('reportConfig:articleOutStock')}
                    checked={!warehouseSelection}
                    onChange={(e) => updateCheckboxAndRadioProperty(e, 'articleOutStock')}
                />*/}
                <CreateOfficeSelect
                    name="officeID"
                    value={formData.officeID}
                    setFormData={setFormData}
                    label={t('orgaUnit')}
                    withSearch
                    errorMessage={formErrors && formErrors.officeID}
                    isInvalid={formErrors && formErrors.officeID}
                    //disabled={warehouseSelection}
                />
                <Form.Check
                    id="includeSubordinatedOffices"
                    label={t('reportConfig:includeSubordinatedOffices')}
                    type="checkbox"
                    name="includeSubordinatedOffices"
                    onChange={(e) => updateCheckboxAndRadioProperty(e, 'includeSubordinatedOffices')}
                    checked={formData.includeSubordinatedOffices}
                    isInvalid={formErrors && formErrors.includeSubordinatedOffices}
                    //disabled={warehouseSelection}
                />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>{t(`reportConfig:emailAddress`)}</Form.Label>
                <Form.Control
                    name="emailAddress"
                    onChange={e => setFormData(prev => ({
                        ...prev,
                        emailAddress: e.target.value
                    }))}
                    value={formData.emailAddress || ''}
                    isInvalid={formErrors && formErrors.emailAddress}
                    autoComplete="email" />
                <Form.Control.Feedback type="invalid">
                    {formErrors && formErrors.emailAddress}
                </Form.Control.Feedback>
            </Form.Group>
            <MandatoryField />
        </div>
    )
}
export default ArticleInstanceExpiringWarrantiesStatistic